import React from "react";

const LeftArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      data-name="Caminho 15754"
      d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
      transform="translate(-4 -4)"
      style={{ fill: "#00625f" }}
    />
  </svg>
);

export default LeftArrow;
